import React from 'react';
import Modal from './Modal/Modal';

const PatientDetailsModal = ({ isOpen, onClose, selectedItem }) => {
  if (!selectedItem) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">{selectedItem.nombre} {selectedItem.apellido}</h2>
          <div className="patient-basic-info">
            <span>{selectedItem.tipo_documento} {selectedItem.documento}</span>
            <span>•</span>
            <span>{selectedItem.edad} años</span>
            <span>•</span>
            <span>{selectedItem.sexo === 'mujer' ? 'Mujer' : 'Hombre'}</span>
          </div>
          <div className="risk-display">
            <span className="risk-label">Riesgo:</span>
            <span className={`risk-badge ${
              selectedItem.riesgo?.toLowerCase().includes('bajo') ? 'bajo' : 
              selectedItem.riesgo?.toLowerCase().includes('medio') ? 'medio' : 
              selectedItem.riesgo?.toLowerCase().includes('alto') ? 'alto' : ''
            }`}>
              {selectedItem.riesgo}
            </span>
          </div>
        </div>
        <div className="modal-details">
          {selectedItem.origen_dato === 'AppSindicato' ? (
            // Vista para datos de AppSindicato
            <>
              <div className="detail-item">
                <div className="detail-label">Peso</div>
                <div className="detail-value">{selectedItem.peso || 'No especificado'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Altura</div>
                <div className="detail-value">{selectedItem.altura || 'No especificado'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Tabaquismo</div>
                <div className="detail-value">{selectedItem.tabaquismo || 'No especificado'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Diabetes Mellitus</div>
                <div className="detail-value">{selectedItem.diabetes_mellitus ? 'Sí' : 'No'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Hipertensión Arterial</div>
                <div className="detail-value">{selectedItem.hipertension_arterial ? 'Sí' : 'No'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Historia Familiar de Infarto Prematuro</div>
                <div className="detail-value">{selectedItem.historia_familiar_infarto_prematuro ? 'Sí' : 'No'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Antecedentes Cerebrovasculares</div>
                <div className="detail-value">{selectedItem.tiene_antecedentes_cerebro_vascular ? 'Sí' : 'No'}</div>
              </div>
            </>
          ) : (
            // Vista para otros orígenes de datos (Excel, etc.)
            <>
              <div className="detail-item">
                <div className="detail-label">Peso</div>
                <div className="detail-value">{selectedItem.peso_kg} kg</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Altura </div>
                <div className="detail-value">{selectedItem.talla_metros} </div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Presión arterial</div>
                <div className="detail-value">{selectedItem.presion_arterial || 'No especificada'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Riesgo a 10 años</div>
                <div className="detail-value">{selectedItem.riesgo}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Diabetes</div>
                <div className="detail-value">{selectedItem.diabetes ? 'Sí' : 'No'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Fumador actual</div>
                <div className="detail-value">{selectedItem.fuma_actualmente ? 'Sí' : 'No'}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">Tratamiento hipertensión</div>
                <div className="detail-value">{selectedItem.tratamiento_hipertension_arterial ? 'Sí' : 'No'}</div>
              </div>
            </>
          )}
          <div className="detail-item">
            <div className="detail-label">Origen del Dato</div>
            <div className="detail-value">
              {selectedItem.origen_dato === 'AppSindicato' ? 'App del Sindicato' : (selectedItem.origen_dato || 'No especificado')}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PatientDetailsModal;
